import type { LoginLocationState } from "../pages/loginFlow.ts";
import type { PersistedSession } from "../sdk/storage.ts";

/** Where the post-login redirect should land for the start route. */
export const START_PATH = "/start";
/** The unauthenticated entry point. */
export const LOGIN_PATH = "/login";

/** A session that is present and truthy unlocks the protected shell. */
export function isAuthenticated(session: PersistedSession | null): boolean {
  return session !== null;
}

/**
 * The router state passed alongside the login redirect so the login page can
 * send the user back to where they were headed. Preserving the path is what
 * keeps a deep link from collapsing to `/` after sign-in.
 */
export function loginRedirectState(pathname: string): LoginLocationState {
  return { from: pathname };
}
